import { useTheme } from '@mui/material';

import { cssColorHexToRgbA } from '~/utils/helpers/css';

export const useSxStyles = () => {
  const theme = useTheme();

  const fadeColor = theme.palette.background.default;
  const fadeAlpha = 0.6;

  return {
    loading: {
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center',
    },
    loader: {},
    loaderMessage: {
      position: 'absolute',
      backgroundImage: `repeating-linear-gradient(90deg, ${cssColorHexToRgbA(
        fadeColor,
        0,
      )} 0%, ${cssColorHexToRgbA(
        fadeColor,
        fadeAlpha,
      )} 30%, ${cssColorHexToRgbA(
        fadeColor,
        fadeAlpha,
      )} 70%, ${cssColorHexToRgbA(fadeColor, 0)} 100%)`,
      backgroundSize: 'cover',
      padding: theme.spacing(0.5),
    },
  };
};
